import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { DocumentFieldItemEdit } from "./edit-item";

const DocumentFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <DocumentFieldItemEdit />
        </FieldListEditWrapper>
    );
};
DocumentFieldEdit.displayName = "DocumentFieldEdit";
export { DocumentFieldEdit };
